import { FieldModel, FieldsAPI, FileDetails } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Dispatch, SetStateAction } from 'react'
import { useInvalidateBatchedFields } from '../../../queries'
import { QUERY_KEY } from '../../../queries/queryKey'

interface UseUploadDetailProps {
  setProgress: Dispatch<SetStateAction<number>>
}

export interface FieldDetailUploadRequest extends FileDetails {
  resourceId: string
  year?: number
  traitId: string
  id?: string
}

export const useUploadDetailFile = ({ setProgress }: UseUploadDetailProps) => {
  const queryClient = useQueryClient()

  const invalidateBatchedFields = useInvalidateBatchedFields()

  return useMutation<any, Error, any>({
    mutationFn: ({ file, resourceId, traitId, ...rest }: FieldDetailUploadRequest) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('resourceId', resourceId)
      formData.append('traitId', traitId)
      Object.keys(rest).map(key =>
        formData.append(
          key,
          // @ts-ignore Yes, this is any. That's intentional.
          rest[key]
        )
      )
      return FieldsAPI.uploadFileDetail(resourceId, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: progressEvent =>
          progressEvent.total && setProgress((progressEvent.loaded / progressEvent.total) * 50),
        onDownloadProgress: progressEvent =>
          progressEvent.total &&
          setProgress(50 + (progressEvent.loaded / progressEvent.total) * 50),
      })
    },

    mutationKey: [QUERY_KEY.SAVE_DETAIL_FILE],
    onSuccess: (result: FieldModel, request: any) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.FIELDS_PAGINATED] })

      invalidateBatchedFields([request.resourceId])
    },
    onError: () => setProgress(0),
  })
}
